export const postStatus = ["Prioritized", "Default", "Hidden"];
